import React from 'react';

const StepOtherSharedForAD = () => (
  <ol>
    <li>
      Notarized copy of the Death Certificate (Death Benefits)
    </li>
    <li>
      Copy of any Police Report (Death Benefits)
    </li>
    <li>
      Copy of the Autopsy including Toxicology Results (Death Benefits)
    </li>
    <li>
      Attending Physician Statement(Dismemberment Benefits)
    </li>
  </ol>
  );
export default StepOtherSharedForAD;



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepOther/components/StepOtherSharedForAD.js